const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY as string;

export async function getPlaceLatLng(inputText: string) {
  try {
    // Autocomplete API - Get placeId
    const autocompleteRes = await fetch(
      'https://places.googleapis.com/v1/places:autocomplete',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Goog-Api-Key': GOOGLE_API_KEY,
        //   'X-Goog-FieldMask': 'predictions.placeId,predictions.displayName',
        },
         body: JSON.stringify({
            input: inputText,
            languageCode: 'en', // Force English language response
            locationRestriction: {
                rectangle: {
                low: {
                    latitude: 6.5546079,
                    longitude: 68.1113787
                },
                high: {
                    latitude: 35.6745457,
                    longitude: 97.395561
                }
                }
            }
        }),
      }
    );

    const autoData = await autocompleteRes.json();
    const suggestions = autoData.suggestions || [];

    if (!suggestions.length) {
      return [];
    }

    // Map the suggestions
    const formattedSuggestions = suggestions.map((item: any) => {
      const prediction = item.placePrediction;
      return {
        text: prediction.text?.text || "", // Full address
        text2: prediction.structuredFormat?.mainText?.text || "", // Main text (e.g. "Delhi cantt railway Junction")
        text3: prediction.structuredFormat?.secondaryText?.text || "", // Secondary text
        placeId: prediction.placeId || "",

      };
    });
    return formattedSuggestions

    

  } catch (err) {
    console.error('Error fetching place:', err);
    throw err;
  }
}

export async function getPlaceDetails(placeId: string){
  const response = await fetch(
    `https://places.googleapis.com/v1/places/${placeId}?fields=location,addressComponents,displayName&languageCode=en`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': GOOGLE_API_KEY,
        // 'X-Goog-FieldMask': 'displayName,location,formattedAddress,addressComponents'
      }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch place details");
  }

  return await response.json();
};
